import React from 'react';
import { SectionWrapper } from './Shared';
import { ShieldCheck } from 'lucide-react';
export const TransformationSection = () => {
  const timeline = [{
    time: 'Primeras 72 horas',
    desc: 'La niebla mental comienza a disiparse.'
  }, {
    time: 'Día 10',
    desc: 'Tu sueño se vuelve tan profundo que te despiertas antes que la alarma.'
  }, {
    time: 'Día 21',
    desc: 'El espejo te devuelve la imagen de un hombre con los ojos encendidos, listo para conquistar el día, no solo para sobrevivir a él.'
  }];
  return <SectionWrapper data-id="element-205">
      <div className="max-w-4xl mx-auto text-center" data-id="element-206">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/10 mb-8" data-id="element-207">
          <ShieldCheck className="w-8 h-8 text-gold-500" data-id="element-208" />
        </div>

        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-16" data-id="element-209">
          La transformación de los{' '}
          <span className="text-gold-500" data-id="element-210">21 días</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-211">
          {timeline.map((item, idx) => <div key={idx} className="bg-dark-800 border border-white/5 p-8 rounded-2xl relative overflow-hidden group hover:border-gold-500/30 transition-all duration-300" data-id="element-212">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-213"></div>
              <h3 className="font-oswald text-xl font-bold text-gold-400 uppercase mb-4" data-id="element-214">
                {item.time}
              </h3>
              <p className="text-zinc-300 text-lg leading-relaxed" data-id="element-215">
                {item.desc}
              </p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};